//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        filter: {
            type: Object,
            required: true
        },
    },

    data () {
        return {
            loading: true,
            total: 0,
            chart: {
                datasets: [
                    {
                        label: this.$lang.get('dashboard.planets-finished.label'),
                        data: [],
                        borderColor: ['#6ED057', '#BD1622', '#2D72A3', '#E9AA53'],
                        backgroundColor: ['#6ED057', '#BD1622', '#2D72A3', '#E9AA53'],
                        pointRadius: 6,
                        pointBorderColor: '#ffffff',
                        pointBorderWidth: '2',
                        fill: false,
                        lineTension: 0,
                    }
                ],
                labels: [],
                beginzero: true,
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [{
                            position: 'left',
                            offset: false,
                            stacked: false,
                            gridLines: {
                                color: '#6B7280',
                                drawBorder: false,
                            },
                            ticks: {
                                min: 0,
                                stepSize: 20,
                                fontColor: '#6B7280',
                                padding: 20,
                            },
                        }],
                        xAxes: [{
                            offset: true,
                            stacked: true,
                            gridLines: {
                                color: '#6B7280',
                                drawBorder: false,
                            },
                            ticks: {
                                fontColor: '#6B7280',
                                padding: 10,
                            },
                        }]
                    }
                },
            },
        };
    },

    mounted () {
        this.loadData();
    },

    methods: {
        loadData() {
            this.loading = true;

            axios.request({
                method: 'GET',
                url: '/dashboard/planets-finished',
                params: {
                    filter: this.filter,
                }
            }).then(response => {
                this.total = response.data.data.total
                this.chart.datasets[0].data = response.data.data.data;
                this.chart.labels = response.data.data.labels;

                this.loading = false;
            }).catch(error => {
                this.loading = false;
            });
        },
    }
};
